<ng-container *ngFor="let filled of slots()">
	<mat-icon *ngIf="icon()"
	          class="xp-rating-stars__icon"
	          [class.xp-rating-stars__icon--filled]="filled">{{ icon() }}</mat-icon>
	<img *ngIf="!icon()"
	     class="xp-rating-stars__image"
	     [src]="filled ? filledSrc() : emptySrc()"
	     alt="" />
</ng-container>
